var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"nav-item dropdown"},[_c('a',{staticClass:"nav-link",attrs:{"id":"navbarDropdown","href":"#","role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('i',{staticClass:"fas fa-power-off fa-2x"})])])
}]

export { render, staticRenderFns }